module.exports = __webpack_public_path__ + "static/media/competition.1853b968.svg";